import React, { Component } from 'react';
import './styles/_AppFooter.css';
export class AppFooter extends Component {

    render() {
        return (null)
    }
}
// <div className="layout-footer">
//             <div className="footer-text-left">
//                 <img alt="Logo" src="assets/layout/images/footer-logo.png" />
//             </div>
//             <div >
//                 {/* <button className="p-link"><i className="fa fa-facebook"></i></button>
//                 <button className="p-link"><i className="fa fa-twitter"></i></button>
//                 <button className="p-link"><i className="fa fa-github"></i></button> */}
//                 <a href="https://www.linkedin.com/company/taxreco/" target="_blank" rel="noopener noreferrer"  className="p-link"><i className="fa fa-linkedin"></i></a>
//                 <a href="https://twitter.com/TaxReco_SaaS" target="_blank" rel="noopener noreferrer" className="p-link"><i className="fa fa-twitter"></i></a>
//                 <a href="https://www.youtube.com/channel/UC7yuf5-TGQYFH0y85F3ylAw" target="_blank" rel="noopener noreferrer"  className="p-link"><i className="fa fa-youtube"></i></a>

//             </div>
//         </div>